import React from "react";
import PropTypes from "prop-types";
import { Divider, Typography } from "@material-ui/core";

const DividerWithText = ({ text }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Divider style={{ flexGrow: 1 }} />
      <Typography variant="body1" style={{ margin: "0 10px" }}>
        {text}
      </Typography>
      <Divider style={{ flexGrow: 1 }} />
    </div>
  );
};

DividerWithText.propTypes = {
  text: PropTypes.string.isRequired
};

export default DividerWithText;
